import { createAction } from '@reduxjs/toolkit';
import { Error } from './types';

// extracted to fix circular dependencies
export const addError = createAction<Error, 'ADD_ERROR'>('ADD_ERROR');
